export const KEY_EMB_ELEMENT_TIMING_IDENTIFIER =
  'emb.element_timing.identifier';
export const KEY_EMB_ELEMENT_TIMING_ELEMENT = 'emb.element_timing.element';
export const KEY_EMB_ELEMENT_TIMING_RENDER_TIME =
  'emb.element_timing.render_time';
export const KEY_EMB_ELEMENT_TIMING_LOAD_TIME = 'emb.element_timing.load_time';
export const KEY_EMB_ELEMENT_TIMING_START_TIME =
  'emb.element_timing.start_time';
export const KEY_EMB_ELEMENT_TIMING_URL = 'emb.element_timing.url';
export const KEY_EMB_ELEMENT_TIMING_NATURAL_WIDTH =
  'emb.element_timing.natural_width';
export const KEY_EMB_ELEMENT_TIMING_NATURAL_HEIGHT =
  'emb.element_timing.natural_height';
